import type { PickerRowVm } from '@krp/sale-ui'

import type { OwnSearchItem } from '../api/searchContracts'

/**
 * Строка выдачи поиска для экрана. Товар можно положить в чек, только когда известны его цена и ставка НДС — их даёт отдельная
 * проекция «строк для продажи»; пока её нет или товара нет в привязанной базе, строка показана, но выключена, и причина написана
 * словами (не пустая цена и не «0»).
 */
export const NO_LINE_REASON = 'Цена и ставка НДС этого товара пока недоступны'
export const NOT_IN_BASE_REASON = 'Товара нет в собственной номенклатуре этого источника'

export interface OwnSaleLine {
  /** Ключ, под которым товар лежит в корзине (карточка собственной номенклатуры). */
  productKey: string
  priceText: string
  unit: string | null
  isWeight: boolean | null
  /** Причина, по которой товар продать нельзя (нет цены, нет ставки НДС); `null` — можно. */
  blockedReason: string | null
}

export function pickerRowOf(item: OwnSearchItem, line: OwnSaleLine | undefined): PickerRowVm {
  if (!item.inCash || item.cardKey === null) {
    return { productKey: item.productId, name: item.name, sku: item.sku, barcode: item.matchedBarcode, priceText: '—', unit: null, isWeight: null, available: false, reason: NOT_IN_BASE_REASON }
  }
  if (line === undefined) {
    return { productKey: item.cardKey, name: item.name, sku: item.sku, barcode: item.matchedBarcode, priceText: '—', unit: null, isWeight: null, available: false, reason: NO_LINE_REASON }
  }
  return {
    productKey: line.productKey,
    name: item.name,
    sku: item.sku,
    barcode: item.matchedBarcode,
    priceText: line.priceText,
    unit: line.unit,
    isWeight: line.isWeight,
    available: line.blockedReason === null,
    reason: line.blockedReason,
  }
}